import { Link } from '@mui/material';
import React from 'react';

import { LegalDocument } from '../../../../domain/config';
import { RequiredText } from '../../../../general/components/required-text';

const authorizedRepAttestation: React.ReactNode = (
  <RequiredText>
    I am an authorized representative with authority to apply for credit on behalf of the business
  </RequiredText>
);

const beneficialOwnerAttestation = 'I own 25% or more of the company';
const controlPersonAttestation = 'I have significant management responsibility (President, CEO, CFO, VP, etc.)';

const consentToCreditReportAttestation = (creditTerms: LegalDocument | null): React.ReactNode => (
  <RequiredText>
    I consent to the terms of Coast&apos;s{' '}
    {creditTerms ? (
      <Link href={creditTerms.url} target="_blank">
        {creditTerms.name}
      </Link>
    ) : (
      'Consumer Credit Report Authorization'
    )}
  </RequiredText>
);

export {
  authorizedRepAttestation,
  consentToCreditReportAttestation,
  controlPersonAttestation,
  beneficialOwnerAttestation,
};
